import z from 'zod';

export const greenlightRegistrationFieldValues = z.object({
  registration: z.string().min(1, 'Registration Required'),
});

export type FormValues = z.infer<typeof greenlightRegistrationFieldValues>;
